import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/questions.action'
import * as fromQuestionActions from '../../../actions/questions.action'
import { editLikertQuestion } from 'api/administration/questions/Edit'
import { IQuestionLikertModel } from 'models/questionLikert.model'
import { getQuestionList } from 'api/administration/questions/List'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { BlockTypes } from 'enum/block-type.enum'

async function getList(instanceId: number) {
  return getQuestionList(instanceId)
}

async function handleEditLicker(
  data: IQuestionLikertModel<
    BlockTypes.BlockSurvey | BlockTypes.BlockEvaluation
  >,
  questionId: number
) {
  return editLikertQuestion(data, questionId)
}

function* editLikertEffectSaga(action: any) {
  try {
    const {
      data: { data, instanceId, questionId },
    } = action
    yield call(handleEditLicker, data, questionId)
    const questionList = yield call(getList, instanceId)
    yield put(fromQuestionActions.Actions.questionsListSuccess(questionList))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editLikertWatcherSaga() {
  yield takeLatest(fromActions.QUESTION_LIKERT_EDIT, editLikertEffectSaga)
}
